const steps = [
  {
    number: "1",
    title: "Phone Diagnosis",
    description: "Describe glass type, size. We confirm fit.",
  },
  {
    number: "2",
    title: "Measure Visit",
    description: "On-site measurement, glass verification.",
  },
  {
    number: "3",
    title: "Order & Install",
    description: "Glass installed in existing frame.",
  },
  {
    number: "4",
    title: "30-Day Guarantee",
    description: "Workmanship guaranteed.",
  },
];

export default function ProcessSection() {
  return (
    <section className="w-full bg-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-roboto font-bold text-2xl md:text-[32px] text-[#064e3b] mb-3">
            Replacement Process
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div key={s.number} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#047857] text-white font-bold text-lg mx-auto mb-3">
                {s.number}
              </div>
              <h3 className="font-bold text-base text-[#064e3b] mb-1">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}